export class TabList {
  constructor(elements) {
    this.elements = elements;
    this.showFirstTab();
  }
  showTab(tabIdentifier) {
    for (const tab of this.elements) {
      if (!(tab instanceof HTMLElement)) {
        continue;
      }
      tab.hidden = tab.dataset.tabIdentifier !== tabIdentifier;
    }
  }
  showFirstTab() {
    for (const tab of this.elements) {
      if (!(tab instanceof HTMLElement)) {
        continue;
      }
      const tabIdentifier = tab.dataset.tabIdentifier;
      if (typeof tabIdentifier === "string") {
        return this.showTab(tabIdentifier);
      }
    }
  }
}
